module.exports = __webpack_public_path__ + "img/pc-alert.5497f068.png";